import React from "react";

const palette = {
  CRITICAL: "bg-[#FEE2E2] text-[#991B1B] border-[#FCA5A5]",
  WARNING: "bg-[#FEF3C7] text-[#B45309] border-[#FCD34D]",
  SUCCESS: "bg-[#DCFCE7] text-[#166534] border-[#86EFAC]",
  INFO: "bg-zinc-100 text-zinc-700 border-zinc-300",
  DELIVERED: "bg-[#DCFCE7] text-[#166534] border-[#86EFAC]",
  ON_VESSEL: "bg-[#E6EBF6] text-[#002FA7] border-[#A7B4D9]",
  AT_ORIGIN: "bg-zinc-100 text-zinc-700 border-zinc-300",
  AT_DESTINATION: "bg-[#E6EBF6] text-[#002FA7] border-[#A7B4D9]",
  BOOKED: "bg-zinc-50 text-zinc-600 border-zinc-300",
  DELAYED: "bg-[#FEF3C7] text-[#B45309] border-[#FCD34D]",
  CUSTOMS_HOLD: "bg-[#FEE2E2] text-[#991B1B] border-[#FCA5A5]",
  HIGH: "bg-[#FEE2E2] text-[#991B1B] border-[#FCA5A5]",
  MEDIUM: "bg-[#FEF3C7] text-[#B45309] border-[#FCD34D]",
  LOW: "bg-[#DCFCE7] text-[#166534] border-[#86EFAC]",
  MATCHED: "bg-[#DCFCE7] text-[#166534] border-[#86EFAC]",
  EXCEPTION: "bg-[#FEE2E2] text-[#991B1B] border-[#FCA5A5]",
  READY: "bg-[#DCFCE7] text-[#166534] border-[#86EFAC]",
  AT_RISK: "bg-[#FEF3C7] text-[#B45309] border-[#FCD34D]",
  PLANNED: "bg-zinc-100 text-zinc-700 border-zinc-300",
  OVERDUE: "bg-[#FEE2E2] text-[#991B1B] border-[#FCA5A5]",
  CRITICAL_DETENTION: "bg-[#FEF3C7] text-[#B45309] border-[#FCD34D]",
  MONITOR: "bg-zinc-100 text-zinc-700 border-zinc-300",
  REQUESTED: "bg-zinc-100 text-zinc-700 border-zinc-300",
};

export default function StatusBadge({ value, label, testId }) {
  const cls = palette[value] || "bg-zinc-100 text-zinc-700 border-zinc-300";
  return (
    <span
      data-testid={testId || `status-badge-${value}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] uppercase tracking-[0.12em] font-medium border ${cls}`}
    >
      <span className="map-dot" style={{ background: "currentColor" }} />
      {label || (value || "").replace(/_/g, " ")}
    </span>
  );
}
